import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { AddressContainer, AdressSpecific, ButtonContainer, InfoSection } from './address.style';
import axios from 'axios';
import { environment, url } from 'src/environments';
export default function Address({ addressInformation }) {
  const user = useSelector((state) => state.user.currentUser);
  const [editable, setEditable] = useState(false);
  const [addressData, setAddressData] = useState({
    investorId: user.id,
    country: '',
    postalCode: '',
    city: '',
    state: '',
    district: '',
    neighborhood: '',
    street: '',
    numInt: '',
    numExt: ''
  });
  const data = addressInformation.getAddress;
  //Function that sends the nwe data to dynamo
  const sendDataToServer = async () => {
    const typeOfPerson = user.typeOfPerson;
    let input = {};
    if (typeOfPerson === 'MORAL') {
      input = {
        type: 'investor_update_personalAddress',
        input: {
          id: `${user.id}_c`,
          postalCode: addressData.postalCode
            ? addressData.postalCode
            : addressInformation.postalCode,
          state: addressData.state ? addressData.state : addressInformation.state,
          district: addressData.district ? addressData.district : addressInformation.district,
          neighborhood: addressData.neighborhood
            ? addressData.neighborhood
            : addressInformation.neighborhood,
          street: addressData.street ? addressData.street : addressInformation.street,
          numInt: addressData.numInt ? addressData.numInt : addressInformation.numInt,
          numExt: addressData.numExt ? addressData.numExt : addressInformation.numExt
        }
      };
    } else if (typeOfPerson === 'FISICA') {
      input = {
        type: 'investor_update_personalAddress',
        input: {
          id: `${user.id}_p`,
          fullAddress: `${addressInformation.fullAddress}_deprecated`,
          postalCode: addressData.postalCode
            ? addressData.postalCode
            : addressInformation.postalCode,
          state: addressData.state ? addressData.state : addressInformation.state,
          district: addressData.district ? addressData.district : addressInformation.district,
          neighborhood: addressData.neighborhood
            ? addressData.neighborhood
            : addressInformation.neighborhood,
          street: addressData.street ? addressData.street : addressInformation.street,
          numInt: addressData.numInt ? addressData.numInt : addressInformation.numInt,
          numExt: addressData.numExt ? addressData.numExt : addressInformation.numExt
        }
      };
    }
    try {
      const response = await axios.post(`${url}/${environment}/admin/dynamo/update`, input);
      setEditable(false);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEdit = () => {
    setEditable(true);
  };
  const cancelEdit = () => {
    setEditable(false);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAddressData({ ...addressData, [name]: value });
  };
  return (
    <AddressContainer>
      {editable ? (
        <ButtonContainer>
          <button onClick={sendDataToServer}>Aceptar</button>
          <button onClick={cancelEdit}>Cancelar</button>
        </ButtonContainer>
      ) : (
        <ButtonContainer>
          <button onClick={() => setEditable(true)}>Editar</button>
        </ButtonContainer>
      )}
      <InfoSection>
        {editable ? (
          <div>
            <h3>Código postal:</h3>
            <input value={addressData?.postalCode} onChange={handleInputChange} name="postalCode" />
          </div>
        ) : (
          <div>
            <h3>Código postal:</h3>
            <p>{data?.postalCode ? data?.postalCode : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Alcaldía o Municipio:</h3>
            <input value={addressData.district} onChange={handleInputChange} name="district" />
          </div>
        ) : (
          <div>
            <h3>Alcaldía o Municipio:</h3>
            <p>{data?.district ? data?.district : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Estado:</h3>
            <input value={addressData.state} onChange={handleInputChange} name="state" />
          </div>
        ) : (
          <div>
            <h3>Estado:</h3>
            <p>{data?.state ? data?.state : '-'}</p>
          </div>
        )}
      </InfoSection>
      <InfoSection>
        {editable ? (
          <div>
            <h3>Número exterior:</h3>
            <input value={addressData.numExt} onChange={handleInputChange} name="numExt" />
          </div>
        ) : (
          <div>
            <h3>Número exterior:</h3>
            <p>{data?.numExt ? data?.numExt : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Número interior:</h3>
            <input value={addressData.numInt} onChange={handleInputChange} name="numInt" />
          </div>
        ) : (
          <div>
            <h3>Número interior:</h3>
            <p>{data?.numInt ? data?.numInt : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Calle:</h3>
            <input value={addressData.street} onChange={handleInputChange} name="street" />
          </div>
        ) : (
          <div>
            <h3>Calle:</h3>
            <p>{data?.street ? data?.street : '-'}</p>
          </div>
        )}
        {editable ? (
          <div>
            <h3>Colonia:</h3>
            <input
              value={addressData.neighborhood}
              onChange={handleInputChange}
              name="neighborhood"
            />
          </div>
        ) : (
          <div>
            <h3>Colonia:</h3>
            <p>{data?.neighborhood ? data?.neighborhood : '-'}</p>
          </div>
        )}
      </InfoSection>
    </AddressContainer>
  );
}
